module.exports = __webpack_public_path__ + "bf.57dda3d7dfaa2542c7db.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/bf.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/bf.svg
// module chunks = styles